import { getOrCreateUniqueBranchLink } from '@/services/DeepLinkService/DeepLinkService'

export type UtmParams = {
  source: string
  medium: string
  campaign: string
}

interface GenerateShareUrlParams {
  baseUrl: string
  userId: string
  slug: string
  aliasPrefix?: string
  utmParams?: UtmParams
}

export const generateShareUrl = async ({
  baseUrl,
  userId,
  slug,
  utmParams,
}: GenerateShareUrlParams): Promise<string | null> => {
  const url = new URL(baseUrl)

  url.searchParams.append('project', slug)
  url.searchParams.append('product', 'presales')
  url.searchParams.append('refuid', userId)

  if (utmParams) {
    Object.entries(utmParams).forEach(([key, value]) => {
      url.searchParams.append(`utm_${key}`, value)
    })
  }
  const urlRedirect = url.toString()

  const linkData = {
    $fallback_url: urlRedirect,
    $web_only: true,
    $marketing_title: 'Theatrical Giveaway',
  }

  const branchLink = await getOrCreateUniqueBranchLink(linkData)
  return branchLink
}
